import PageHeaderStatusRow from 'components/PageHeaderStatusRow/PageHeaderStatusRow'
import styles from './PageHeader.module.scss'
import AsyncTypography from 'components/AsyncTypography/AsyncTypography'
import MenuListPopUp from 'components/MenuListPopUp/MenuListPopUp'
import { WppTypography } from '@wppopen/components-library-react'
import clsx from 'clsx'
import type { ReactNode } from 'react'

interface PageHeaderProps {
  isLoading?: boolean
  tags: (JSX.Element | undefined | false)[]
  createdDetails: string
  pageTitle: string
  beforeDetails?: ReactNode
  details?: { [key: string]: string }
  menuItems?: { label: string; onClick: () => void }[]
  className?: string
  image?: string
}

export default function PageHeader({
  isLoading,
  tags,
  createdDetails,
  pageTitle,
  beforeDetails,
  details,
  menuItems,
  className,
  image,
}: PageHeaderProps) {
  return (
    <div className={clsx(className)} data-testid="page-details-header">
      <PageHeaderStatusRow isLoading={isLoading} tags={tags} text={createdDetails} />

      <div className={styles.nameAndActions}>
        <div className={styles.titleContainer}>
          <div className={styles.titleInner}>
            {image && !isLoading && (
              <img
                src={image}
                alt={`${pageTitle}-logo`}
                height={50}
                className={styles.image}
                data-testid="client-image"
              />
            )}
            <AsyncTypography
              isLoading={isLoading}
              type="4xl-display"
              tag="h1"
              dataTestId="page-header-title"
              width={310}
            >
              {pageTitle}
            </AsyncTypography>
          </div>

          <div className={styles.projectDetails}>
            {!isLoading && (
              <>
                {beforeDetails}
                {Object.entries(details ?? {}).map(([key, value]) => (
                  <AsyncTypography
                    key={key}
                    isLoading={isLoading}
                    type="xs-body"
                    tag="p"
                    dataTestId={`page-header-${key}`}
                  >
                    {key}:{' '}
                    <WppTypography type="xs-strong" tag="span">
                      {value}
                    </WppTypography>
                  </AsyncTypography>
                ))}
              </>
            )}
          </div>
        </div>

        {/* menu */}
        {menuItems && <MenuListPopUp menuItems={menuItems} isDisabled={isLoading} />}
      </div>
    </div>
  )
}
